import { Controller } from "@hotwired/stimulus"

// The contact form's classification: pick one, or "New classification…" to
// name a kind of a built-in one (contacts/_classification_field).
export default class extends Controller {
  static targets = ["select", "newFields", "name"]

  connect() {
    this.toggle()
  }

  toggle() {
    const adding = this.selectTarget.value === "__new__"
    this.newFieldsTarget.hidden = !adding
    this.newFieldsTarget.querySelectorAll("input, select").forEach((field) => { field.disabled = !adding })
    if (adding && document.activeElement === this.selectTarget) this.nameTarget.focus()
  }
}
